<template>
  <div class="h-unassigned-room">
    <div class="h-unassigned-room__number">{{ orderNumber }}.</div>
    <div class="h-unassigned-room__status" :title="room.status.name">
      <component :is="statusIcon(room.status && room.status.code)" aria-hidden="true"/>
    </div>
    <div class="h-unassigned-room__part h-unassigned-room__part--main">
      <div class="h-unassigned-room__row">
        <div class="h-unassigned-room__col">
          <div class="h-unassigned-room__title">
            <img src="@/assets/img/hm/warning.svg" alt="">
            {{ room.short_room.room_category.name }}
          </div>
        </div>
        <div class="h-unassigned-room__col">
          <div class="h-unassigned-room__dates">
            <CalendarIcon aria-hidden="true"/>
            <span>{{ fmtDate(room.short_room.check_in) }}</span>
            <ArrowIcon />
            <span>{{ fmtDate(room.short_room.check_out) }}</span>
          </div>
        </div>
      </div>
      <div class="h-unassigned-room__row">
        <div class="h-unassigned-room__col">
          <HMTower horizontal>
            <template #title>Balance:</template>
            <template #body>
              <HMBalance :balance="room.balance"/>
            </template>
          </HMTower>
        </div>
        <div class="h-unassigned-room__col">
          <HMChipList>
            <HMChip>
              {{ room.short_room.nights || '0' }}
              <template #icon>
                <NightsIcon aria-hidden="true"/>
              </template>
            </HMChip>
            <HMChip
              v-if="room.reservation?.meal_plan?.name"
              :title="room.reservation.meal_plan.full_name"
              :color="room.reservation.meal_plan.color"
              isMeal
            >
              {{ room.reservation.meal_plan.name }}
            </HMChip>
            <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.adult" color="#9AB992">
              {{ room.short_room.accomodation_type.age_assignment.adult }}
              <template #icon>
                <AdultIcon aria-hidden="true"/>
              </template>
            </HMChip>
            <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.teenager" color="#76A9B4">
              {{ room.short_room.accomodation_type.age_assignment.teenager }}
              <template #icon>
                <TeenagerIcon aria-hidden="true"/>
              </template>
            </HMChip>
            <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.child" color="#D493B0">
              {{ room.short_room.accomodation_type.age_assignment.child }}
              <template #icon>
                <ChildIcon aria-hidden="true"/>
              </template>
            </HMChip>
          </HMChipList>
        </div>
      </div>
    </div>
    <div v-if="room.guests && room.guests.length > 0" class="h-unassigned-room__part h-unassigned-room__part--guests">
      <div class="h-unassigned-room__guests">
        <div
          v-for="guest in room.guests"
          :key="`guest_${guest.id}`"
          class="h-unassigned-room__guest"
        >
          <span class="h-unassigned-room__gender">
            <MaleIcon v-if="guest.gender && guest.gender.code === 'male'"/>
            <FemaleIcon v-else-if="guest.gender && guest.gender.code === 'female'"/>
          </span>
          <HMTooltip>
            <template #trigger>
              <span
                :class="{ 'h-unassigned-room__flag--empty': !(guest.citizenship && guest.citizenship.code) }"
                :title="guest.citizenship && guest.citizenship.name ? guest.citizenship.name : ''"
                class="h-unassigned-room__flag"
              >
                <span v-if="guest.citizenship && guest.citizenship.code" :class="`fflag ff-md fflag-${guest.citizenship.code}`"></span>
              </span>
            </template>
            <template #content>{{ guest.citizenship?.name }}</template>
          </HMTooltip>
          <span class="h-unassigned-room__guest-name">
            {{ (guest.gender && guest.gender.greeting) ? guest.gender.greeting : '' }} {{ guest.full_name || ((guest.first_name || '') + ' ' + (guest.last_name || '')) }}
          </span>
        </div>
      </div>
    </div>
    <div class="h-unassigned-room__part h-unassigned-room__part--assign">
      <app-form-field label="Assign Room:" class="family" labelLeft>
        <app-select
          @input="onInputAssignRoom"
          @open="onOpenAssignRoom"
          v-model="assignRoom"
          :options="rooms_available"
          :clerable="false"
          :searchable="false"
          :filterable="false"
          label="room_name"
          placeholder="Choose available room"
          class="family select--300"
        />
      </app-form-field>
    </div>
  </div>
</template>

<script>
import CheckIn from '@/views/hotel-management/reservations/detail/icons/CheckIn.vue'
import CheckOut from '@/views/hotel-management/reservations/detail/icons/CheckOut.vue'
import NotCheckIn from '@/views/hotel-management/reservations/detail/icons/NotCheckIn.vue'
import CalendarIcon from '@/views/hotel-management/reservations/detail/icons/CalendarIcon.vue'
import ArrowIcon from '@/views/hotel-management/reservations/detail/icons/ArrowIcon.vue'
import HMTower from '@/components/HMTower.vue'
import HMAgeAssignment from '@/components/HMAgeAssignment.vue'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'
import TeenagerIcon from '@/views/hotel-management/reservations/detail/icons/TeenagerIcon.vue'
import AdultIcon from '@/views/hotel-management/reservations/detail/icons/AdultIcon.vue'
import ChildIcon from '@/views/hotel-management/reservations/detail/icons/ChildIcon.vue'
import HMChipList from '@/views/hotel-management/reservations/components/HMChipList.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import MaleIcon from '@/views/hotel-management/reservations/detail/icons/MaleIcon.vue'
import FemaleIcon from '@/views/hotel-management/reservations/detail/icons/FemaleIcon.vue'
import HMTooltip from '@/views/hotel-management/reservations/components/HMTooltip.vue'
import { getHotelManagementRoomsAvailable, patchHotelManagementReservationsRooms } from '@/http'

export default {
  name: 'HotelUnassignedRoom',
  components: {
    HMTooltip,
    FemaleIcon,
    MaleIcon,
    HMChip,
    NightsIcon,
    HMChipList,
    ChildIcon,
    AdultIcon,
    TeenagerIcon,
    HMBalance,
    HMAgeAssignment,
    HMTower,
    ArrowIcon,
    CalendarIcon,
    CheckIn,
    CheckOut,
    NotCheckIn
  },
  props: {
    orderNumber: { type: Number, default: 0 },
    room: { type: Object, required: true },
  },
  data() {
    return {
      assignRoom: null,
      rooms_available: [],
    }
  },
  methods: {
    onInputAssignRoom() {
      patchHotelManagementReservationsRooms(this.room.id, { room: this.assignRoom.id })
        .then(() => { this.$emit('room-patched') })
    },
    onOpenAssignRoom() {
      if (this.rooms_available && this.rooms_available.length === 0) {
        getHotelManagementRoomsAvailable({
          from_date: this.room.short_room.check_in,
          to_date: this.room.short_room.check_out,
          room_category: this.room.short_room.room_category.id,
          property: this.room.reservation.property.code
        })
          .then(res => { this.rooms_available = res.data })
      }
    },
    statusIcon(code) {
      const map = { checked_in: 'CheckIn', checked_out: 'CheckOut', not_checked_in: 'NotCheckIn' }
      return map[code] || 'NotCheckIn'
    },
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(`${ iso }T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }, ${ d.getFullYear() }`
    },
  }
}
</script>

<style scoped>
.h-unassigned-room {
  position: relative;
  margin-bottom: 10px;
  border-radius: 16px;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}

.h-unassigned-room:last-child {
  margin-bottom: 0;
}

.h-unassigned-room__number {
  position: absolute;
  top: 20px;
  left: 24px;
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.h-unassigned-room__status {
  position: absolute;
  top: 40px;
  left: -9px;
  width: 38px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('~@/views/hotel-management/reservations/detail/icons/plug-status.svg');
}

.h-unassigned-room__part {
  border-bottom: 1px solid #e9e9e9;
}

.h-unassigned-room__part:last-child {
  border-bottom: none;
}

.h-unassigned-room__part--main {
  padding: 16px 20px 25px 58px;
}

.h-unassigned-room__part--guests {
  padding: 14px 20px 16px 24px;
}

.h-unassigned-room__part--assign {
  padding: 13px 20px 15px 27px;
}

.h-unassigned-room__row {
  display: grid;
  grid-template-columns: 200px 1fr;
  margin-bottom: 10px;
}

.h-unassigned-room__row:last-child {
  margin-bottom: 0;
}

.h-unassigned-room__title {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.h-unassigned-room__dates {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
}

.h-unassigned-room__guests {
  display: flex;
  gap: 20px;
}

.h-unassigned-room__guest {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.h-unassigned-room__gender {
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.h-unassigned-room__flag {
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  border: 1px solid #b5b5b5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #fff;
  overflow: hidden;
}

.h-unassigned-room__flag--empty {
  background: #efefef;
  border-color: #efefef;
}

.h-unassigned-room__guest-name {
  color: #000;
  font-size: 15px;
  font-family: 'CoreSansCR', sans-serif;
  font-weight: 500;
}
</style>